import template from './price-with-vat.jade';

export default angular.module('cian.addForm.priceWithVat', []).directive('cianAfPriceAndDealTermsPriceWithVat', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    function () {
      this.ad.bargainTerms = this.ad.bargainTerms || {};
      this.ad.bargainTerms.priceType = 'all';

      this.isRateVisible = () => this.ad.totalArea && this.ad.bargainTerms.price;
      this.getComputedRate = () => {
        return this.ad.totalArea ? this.ad.bargainTerms.price / this.ad.totalArea : '';
      };
    },
  ],
  controllerAs: 'priceWithVat',
  template,
})).name;
